import { useMemo } from 'react';
import { omitBy, isNil } from 'lodash';

import { EMPTY_STRING } from '@e-socna/empty';

import type { FolderStateForm_FolderArchiveInfo } from '../fragments/folder-archive-info.fragment';

export const useInitialValuesFactory = (
  pInitialValues?: Readonly<Partial<FolderStateForm_FolderArchiveInfo>>,
) => {
  const initialValues: FolderStateForm_FolderArchiveInfo = useMemo(
    () => ({
      __typename: 'FolderArchiveInfo' as const,
      endDateForAnalytics: EMPTY_STRING,
      startDateForAnalytics: EMPTY_STRING,
      ...omitBy(pInitialValues, isNil),
    }),
    [pInitialValues],
  );

  return { initialValues };
};
